<template>
  <div>
    <b-tabs lazy>
      <b-tab title="Sold devices:" disabled></b-tab>
      <b-tab title="Products" title-link-class="text-info">
        <ulu-devices-sold-details-chart />
      </b-tab>
      <b-tab title="Agents" title-link-class="text-info">
        <ulu-devices-sold-details-agents-chart />
      </b-tab>
      <b-tab title="Order 1st/Other" title-link-class="text-info">
        <ulu-devices-sold-details-new-chart />
      </b-tab>
      <b-tab title="Comparing" title-link-class="text-info">
        <ulu-devices-sold-years-chart />
      </b-tab>
      <b-tab title="Cumulative" title-link-class="text-info">
        <ulu-devices-sold-years-cumulative-chart />
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
export default {
  components: {
    "ulu-devices-sold-details-chart": () =>
      import("@/components/dashboard/devices/DevicesSoldDetailsChart"),
    "ulu-devices-sold-details-agents-chart": () =>
      import("@/components/dashboard/devices/DevicesSoldDetailsAgentsChart"),
    "ulu-devices-sold-details-new-chart": () =>
      import("@/components/dashboard/devices/DevicesSoldDetailsNewChart"),
    "ulu-devices-sold-years-chart": () =>
      import("@/components/dashboard/devices/DevicesSoldYearsChart"),
    "ulu-devices-sold-years-cumulative-chart": () =>
      import("@/components/dashboard/devices/DevicesSoldYearsCumulativeChart"),
  }
};
</script>
